import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import {useAppDispatch,} from "../../../app/hooks";

import { Input } from "../../../components/ui/input/SimpleInput";
import SelectDropdownV2 from "../../../components/ui/selectdropdown/v2";


import { OptionNameValuePair } from "../../../lib/interfaces/types";
import { PARTY_TYPE_LABELS, PARTY_TYPE_OPTIONS } from "../../../api/PartiesInvolved";

import { upsertPartiesInvolvedThunk } from "../../partiesinvolved/logic/PartiesInvolvedActionsThunk";
import { AddEntitiesModal } from "./AddEntitiesModal";
import { showErrorToast } from "../../../lib/toast";

interface AddPartyModalProps {
  onClose: () => void;
  onBack?: () => void;
}

const AddPartyModal: React.FC<AddPartyModalProps> = ({
  onClose,
  onBack,
}) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();

  const [partyName, setPartyName] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const [selectedPartyType, setSelectedPartyType] =
    useState<OptionNameValuePair<string>>();


  const partyTypeOptions = Object.values(
    PARTY_TYPE_OPTIONS
  ).map((value) => ({
    name: PARTY_TYPE_LABELS[value as keyof typeof PARTY_TYPE_LABELS] ?? value,
    value,
  }));

  const handleDiscard = () => {
    setPartyName("");
    setSelectedPartyType(undefined);
    onClose();
  };

  const handleSave = async () => {
    if ( !caseId || !partyName.trim() ||!selectedPartyType) {
      return;
    }

    setIsSaving(true);

    const newParty = {
      party_id: uuidv4(),
      name: partyName.trim(),
      party_type: selectedPartyType.value,
    };

    try {
      await dispatch(
        upsertPartiesInvolvedThunk({
          case_id: caseId,
          request: {
            parties_involved: [newParty],
          },
        })
      ).unwrap();

      onClose();

    } catch (error) {
       showErrorToast("Failed to save changes. Please try again.");
    }finally {
       setIsSaving(false);
    }
  };

  return (
    <AddEntitiesModal
      title="Add Party Details"
      onClose={onClose}
      onBack={onBack}
      onDiscard={handleDiscard}
      onSave={handleSave}
      saveEnabled={
        !!partyName &&
        !!selectedPartyType &&
        !isSaving
      }
      isSaving={isSaving}
    >
      <div>
        <label className="block text-sm font-medium text-[#0A0A0A] mb-1">
          Party Name
        </label>

        <Input
          type="text"
          placeholder="Enter party name"
          value={partyName}
          onChange={e => setPartyName(e.target.value)}
          disabled={isSaving}
          className="
            h-9
            px-3
            border-[#E5E5E5]
            shadow-[0_1px_2px_rgba(0,0,0,0.05)]
          "
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-[#0A0A0A] mb-1">
          Type
        </label>

        <SelectDropdownV2
          name="Party Type"
          options={partyTypeOptions}
          selectedOption={selectedPartyType}
          onSelectionChange={setSelectedPartyType}
          enableSearch={false}
          disabled={isSaving}
          containerClassName="
            border border-[#E5E5E5]
            rounded-md
            bg-white
            shadow-[0_1px_2px_rgba(0,0,0,0.05)]
          "
          labelClassName="h-9 py-2 px-3"
        />
      </div>
    </AddEntitiesModal>
  );
};

export default AddPartyModal;